export default function () {
  function matomoPush(data: Record<string, unknown>) {
    if (import.meta.server) {
      // No server-side implementation needed for Matomo Tag Manager
      return
    } else {
      try {
        if (!window._mtm) {
          window._mtm = []
        }
        window._mtm.push(data)
      } catch {
        // Noop.
      }
    }
  }

  function trackSwitchPage(referrer: unknown, location: string, title: string) {
    // Track in Matomo Tag Manager
    matomoPush({
      event: 'switch_page',
      page_referrer: referrer || undefined,
      page_location: location,
      page_title: title,
    })
  }

  return {
    matomoPush,
    trackSwitchPage,
  }
}

declare global {
  interface Window {
    _mtm: unknown[]
  }
}
